import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ConfService} from '../../conf.service';
import {Router} from '@angular/router';
import {KongService} from '../../kong.service';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel.component';

@Component({
  selector: 'app-foreign-key-constraints',
  templateUrl: './foreign-key-constraints.component.html',
  styleUrls: ['./foreign-key-constraints.component.scss']
})
export class ForeignKeyConstraintsComponent implements OnInit {

  constructor(private dialog: MatDialog, private confPost: ConfService, private platform: LeftpanelComponent) { }

  @Input() referentialKeyConstraints = [];
  @Input() apiDefinition: any;
  @Input() selectedDatabase: any;
  @Input() selectedDataTypeFilter: any;
  @Input() partner: any;
  @Input() account: any;
  @Input() pkey: any;
  @Input() editMode: any;
  @Input() sourceTable: any;
  @Input() name: any;
  @Input() version: any;
  referencePrimaryKeys: any;

  ngOnInit() {
  }

  patchConstraints() {
    const payload = {
      entityname: this.name,
      version: this.version,
      referentialKeyConstraints: this.referentialKeyConstraints,
      database: this.selectedDatabase,
      tableName: this.sourceTable
    };
    this.confPost.patchEntity(this.partner, this.account, payload).subscribe(response => {

    }, error => {
      this.platform.notifyErrorToAdmins({error: 'Error occurred while patching the constraints for the partner ' + this.partner + ' in the entity ' + this.name + ' with version' + this.version + 'while editing DAAS.'}, 'update_entity_success', 'update_entity_failed', 'Error occurred while patching the constraints for the partner ' + this.partner + ' in the entity ' + this.name + ' with version' + this.version + 'while editing DAAS.', {partner: this.partner, account: this.account, data: payload});
    });
  }

  AddForeignKey() {
    const constraint = {
      constraintName: '',
      columnMappings: [],
      referenceTable: '',
      onDelete: 'NO ACTION',
      onUpdate: 'NO ACTION'
    };
    const addForeignKeyDialog = this.dialog.open(AddForeignKeyConstraintComponent, {
      width: '60vw',
      maxHeight: '60vh',
      data: {
        constraint: constraint,
        database: this.selectedDatabase,
        apiDefinition: this.apiDefinition,
        databaseType: this.selectedDataTypeFilter,
        partner: this.partner,
        pkey: this.pkey,
        editMode: this.editMode,
        tableName: this.sourceTable
      }
    });

    addForeignKeyDialog.afterClosed().subscribe(response => {
      if (response && response !== null && response !== undefined && response.event === 'data') {
        this.referentialKeyConstraints.push(response.data.constraint);
        if (this.editMode === true) {
          this.patchConstraints();
        }
      }
    });
  }

  viewConstraint(constraint) {
    const addForeignKeyDialog = this.dialog.open(ViewForeignKeyConstraintComponent, {
      width: '60vw',
      maxHeight: '60vh',
      data: {
        constraint: constraint,
        apiDefinition: this.apiDefinition
      }
    });
  }

  removeConstraint(constraint, index) {
    if (confirm('Are you sure you want to remove this foreign key?')) {
      if (this.editMode === false) {
        this.referentialKeyConstraints.splice(index, 1);
      } else if (this.editMode === true) {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
          maxWidth: '95vw',
          maxHeight: '60vh',
        });
        const payloadToSend = [];
        constraint['updateOption'] = 'drop';
        payloadToSend.push(constraint);
        this.confPost.addOrDeleteForeignKeyConstraints(this.partner, this.selectedDataTypeFilter, this.selectedDatabase, this.sourceTable, this.pkey, payloadToSend).subscribe(response => {
          if (response && response !== null && response !== undefined) {
            if (response.status === 200 || response.status === 201) {
              loaderDialog.close();
              this.referentialKeyConstraints.splice(index, 1);
              this.patchConstraints();
            } else {
              this.platform.openSnackBar('Error while removing constraint. Please try again after sometime.', 'Error', {
                duration: 4000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              loaderDialog.close();
            }
          }
        }, error => {
          this.platform.handleErrorGracefully(error, 'Error while removing constraint. Please try again after sometime.');
          loaderDialog.close();
        });
      }
    }
  }

}

@Component({
  selector: 'add-foreign-key-constraint',
  templateUrl: 'add-foreign-key-constraint/add-foreign-key-constraint.component.html',
  styleUrls: ['add-foreign-key-constraint/add-foreign-key-constraint.component.css']
})
export class AddForeignKeyConstraintComponent implements OnInit {

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<AddForeignKeyConstraintComponent>, public confPost: ConfService, public router: Router, public kongService: KongService) {
    dialogRef.disableClose = true;
  }
  tablesWithPrimaryKeys: any;
  apiDefinition = [];

  tables = [];

  onDeleteAndOnUpdateConstraints = [
      'RESTRICT', 'CASCADE', 'SET NULL', 'NO ACTION', 'NO DEFAULT'
  ];

  loading = true;

  setAttributeType(event, column) {
    this.data.apiDefinition.filter(items => {
      if (items.attributeName === event) {
        column['columnType'] = items.type;
      }
    });
  }

  ngOnInit() {
    this.confPost.getTablesListWithPrimaryKeysForADatabaseConnection(this.data.partner, this.data.databaseType, this.data.database, this.data.pkey).subscribe(response => {
      if (response.status === 200) {
        this.loading = false;
        if (response.body && response.body !== null && response.body !== undefined) {
          this.tablesWithPrimaryKeys = response.body;
          if (this.tablesWithPrimaryKeys.length === 0) {
            this.platform.openSnackBar('There are no tables associated with the database. Please try with some other database.', 'Error', {
              duration: 15000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            this.close();
          }
        } else {
          this.loading = false;
          this.platform.openSnackBar('Error while fetching tables and keys. Please try again after sometime', 'Error', {
            duration: 15000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.close();
        }
      } else {
        this.loading = false;
        this.platform.openSnackBar('Error while fetching tables and keys. Please try again after sometime', 'Error', {
          duration: 15000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.close();
      }
    }, error => {
      if (error.hasOwnProperty('status')) {
        if (error.status === 403) {
          this.loading = false;
          this.platform.openSnackBar('This operation is not allowed for the database type ' + this.data.databaseType + '. Please try with some other database.', 'Error', {
            duration: 15000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        } else {
          this.loading = false;
          this.platform.openSnackBar('Error while fetching tables and keys. Please try again after sometime', 'Error', {
            duration: 15000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }
      this.close();
    });
  }

  addConstraint() {
    if (this.data.constraint.constraintName === null || this.data.constraint.constraintName === undefined || this.data.constraint.constraintName === '' || this.data.constraint.referenceTable === null || this.data.constraint.referenceTable === undefined || this.data.constraint.referenceTable === '') {
      this.platform.openSnackBar('Please fill all the required attributes.', 'Error', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    } else {
      if (this.data.editMode === false) {
        this.dialogRef.close({event: 'data', data: this.data});
      } else if (this.data.editMode === true) {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
          maxWidth: '95vw',
          maxHeight: '60vh',
        });
        const payloadToSend = [];
        this.data.constraint['updateOption'] = 'add';
        payloadToSend.push(this.data.constraint);
        this.confPost.addOrDeleteForeignKeyConstraints(this.data.partner, this.data.databaseType, this.data.database, this.data.tableName, this.data.pkey, payloadToSend).subscribe(response => {
          if (response && response !== null && response !== undefined) {
            if (response.status === 200 || response.status === 201) {
              loaderDialog.close();
              this.dialogRef.close({event: 'data', data: this.data});
            } else {
              this.platform.openSnackBar('Error while adding constraints. Please try again after sometime.', 'Error', {
                duration: 4000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              loaderDialog.close();
              this.close();
            }
          }
        }, error => {
          this.platform.handleErrorGracefully(error, 'Error while adding constraints. Please try again after sometime.');
          loaderDialog.close();
          this.close();
        });
      }
    }
  }

  getKeys(event) {
    let isIdPresent = false;
    let primaryKeys = [];
    this.apiDefinition = JSON.parse(JSON.stringify(this.data.apiDefinition));
    this.data.constraint.columnMappings = [];
    this.tablesWithPrimaryKeys.filter(items => {
      if (items.tableName === event) {
        primaryKeys = items.primaryAttributes;
      }
    });
    primaryKeys.forEach(key => {
      if (key && key !== null && key !== undefined) {
        const keyObject = {
          columnName: '',
          columnType: '',
          refColumn: key['attributeName'],
          refColumnType: key['type']
        };
        this.data.constraint.columnMappings.push(keyObject);
      }
    });

      this.apiDefinition.forEach(def => {
          if (def['attributeName'] === 'id') {
              isIdPresent = true;
          }
      });

      if (isIdPresent === false) {
          this.apiDefinition.push({'attributeName': 'id', 'type': 'int'});
      }

    this.data.constraint.columnMappings.forEach(constraint => {
      if (constraint && constraint !== null && constraint !== undefined) {
        this.apiDefinition.forEach(def => {
          if (def && def !== null && def !== undefined && def.hasOwnProperty('attributeName')  && def.hasOwnProperty('type')) {
            if (def['attributeName'] === constraint['refColumn'] && def['type'] === constraint['refColumnType']) {
              constraint['columnName'] = def['attributeName'];
              constraint['columnType'] = def['type'];
            }
          }
        });
      }
    });
  }

  close() {
    this.dialogRef.close({event: 'close'});
  }
}

@Component({
  selector: 'view-foreign-key-constraint',
  templateUrl: 'view-foreign-key-constraint/view-foreign-key-constraint.component.html',
  styleUrls: ['view-foreign-key-constraint/view-foreign-key-constraint.component.css']
})
export class ViewForeignKeyConstraintComponent implements OnInit {

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<ViewForeignKeyConstraintComponent>, public confPost: ConfService, public router: Router, public kongService: KongService) {
  }

  onDeleteAndOnUpdateConstraints = [
    'RESTRICT', 'CASCADE', 'SET NULL', 'NO ACTION', 'NO DEFAULT'
  ];

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }
}
